"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getISO3Country = void 0;
var countries_1 = require("../constants/countries");
var getISO3Country = function (country) {
    if (!Object.prototype.hasOwnProperty.call(countries_1.ISO3COUNTRIES, country)) {
        throw new Error('No match found.');
    }
    return countries_1.ISO3COUNTRIES[country];
};
exports.getISO3Country = getISO3Country;
